<template>
  <v-container>
    <v-layout v-if="loading">
      <v-flex>
        <v-progress-circular
          v-if="loading"
          indeterminate
          class="primary--text"
          :width="7"
          :size="10"
        />
      </v-flex>
    </v-layout>
    <v-layout
      v-else-if="paginatedVideos.length == 0 && !loading"
      row
    >
      <v-flex xs12>
        <v-card
          class="pa-2"
          elevation="1"
          target="_blank"
          href="http://brocheballetonline.com/technique-library"
        >
          <v-row>
            <v-col
              v-if="$vuetify.breakpoint.mdAndUp"
              l="2"
              md="3"
            >
              <v-img
                class="ma-5"
                :aspect-ratio="16/9"
                src="https://storage.googleapis.com/video-storage.brocheballet.com/Start%20Bookmarking.png"
                contain
              />
            </v-col>
            <v-col>
              <p class="custom-title pt-3">
                Get started watching videos!
              </p>
              <p>Classes you take on-demand will appear here.</p>
            </v-col>
          </v-row>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout
      v-else-if="paginatedVideos.length > 0 && $vuetify.breakpoint.smAndUp && !loading"
      row
      wrap
    >
      <v-flex
        v-for="video in paginatedVideos"
        :key="video.id"
        xs12
      >
        <v-card
          class="pa-2"
          :href="video.pageURL"
          target="_blank"
          elevation="1"
        >
          <v-row>
            <v-col
              l="2"
              md="3"
            >
              <v-img
                class="ma-5"
                :aspect-ratio="16/9"
                :src="video.videoThumbURL"
                contain
              />
            </v-col>
            <v-col>
              <p class="custom-title pt-3">{{ video.title }}</p>
              <p>Watched {{ formatDateAdded(video) }}</p>
              <p class="pt-3"><v-icon dense>mdi-play</v-icon> Watch again</p>
            </v-col>
          </v-row>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout
      v-else-if="paginatedVideos.length > 0 && $vuetify.breakpoint.xs && !loading"
      row
      wrap
    >
      <v-flex
        v-for="video in paginatedVideos"
        :key="video.id"
        xs12
      >
        <v-card
          class="pa-2"
          :href="video.pageURL"
          target="_blank"
          elevation="1"
        >
          <v-row>
            <v-img
              class="ma-5"
              :aspect-ratio="16/9"
              :src="video.videoThumbURL"
              contain
            />
            <p class="custom-title">{{ video.title }}</p>
            <p>Watched on {{ formatDateAdded(video) }}</p>
          </v-row>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="paginatedVideos.length > 1 && !loading"
      row
    >
      <v-flex xs12>
        <v-pagination
          v-if="paginationLength > 1"
          v-model="page"
          :length="paginationLength"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import moment from 'moment-timezone'
  export default {
    props: ['id'],
    data () {
      return {
        page: 1,
        itemsPerPage: 9,
        maxItems: 0
      }
    },
    computed: {
      watchedVideos () {
        return this.$store.getters.loadedVideoWatchHistoryForCurrentDancer
      },
      paginatedVideos () {
        var startIndex = (this.page - 1) * this.itemsPerPage
        var endIndex = (this.page) * this.itemsPerPage
        var videos = this.watchedVideos.slice(startIndex, endIndex)
        if (this.maxItems > 0) {
          return videos.slice(0, this.maxItems)
        } else {
          return videos
        }
      },
      paginationLength () {
        return Math.ceil(this.watchedVideos.length / this.itemsPerPage)
      },
      loading () {
        return this.$store.getters.loading
      }
    },
    created () {
      this.$store.dispatch('logDancerInByMemberstackID', this.id).then(() => {
        this.$store.dispatch('loadVideoWatchHistoryForCurrentDancer')
      })
      if (this.$route.query.embed) {
        this.$store.commit('setLayout', 'embed-layout')
      }
      if (this.$route.query.limit) {
        this.maxItems = this.$route.query.limit
      }
    },
    methods: {
      formatDateAdded (video) {
        return moment(parseInt(video.dateAdded)).format('MMMM D, YYYY')
      }
    }
  }
</script>

<style>
  p {
    font-size:14px;
    font-family: "Fanwood Text";
    justify-content: left;
    color:rgba(40,26,23,.6);
    font-weight:400;
    padding: 0 20px;
    margin-bottom:5px !important;
  }

  p.custom-title {
    font-size:20px;
  }
</style>
